export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-gradient-to-br from-background-100 to-background-200/50 rounded-2xl border border-background-300/40 p-6 md:p-10 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>

          <div className="flex-1 relative z-10 text-center lg:text-left">
            <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-500/10 text-secondary-400 text-xs font-medium mb-4 whitespace-nowrap">
              <i className="ri-smartphone-line text-xs"></i>
              移动观影
            </span>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-3">
              手机观影
            </h2>
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              四虎影视大全全面适配移动端浏览器，无需下载APP即可在手机上流畅观看高清影视。智能适配竖屏模式，通勤路上、午休时间，随时随地享受影院级观影体验。收藏本站到手机桌面，一键直达您的私人影院。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-3 px-5 py-3 bg-background-200/80 rounded-xl border border-background-300/50">
                <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-android-line text-foreground-50 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-foreground-300 font-medium text-sm">Android 端</div>
                  <div className="text-foreground-600 text-xs">浏览器即用</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 bg-background-200/80 rounded-xl border border-background-300/50">
                <div className="w-10 h-10 flex items-center justify-center bg-foreground-100 rounded-lg">
                  <i className="ri-apple-line text-background-900 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-foreground-300 font-medium text-sm">iOS 端</div>
                  <div className="text-foreground-600 text-xs">Safari 即开即看</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 relative z-10">
            <div className="w-[200px] md:w-[240px] aspect-[9/16] rounded-2xl overflow-hidden bg-background-200/70 border-2 border-background-300/50">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20streaming%20app%20mobile%20interface%20mockup%20on%20smartphone%20screen%2C%20dark%20theme%20with%20warm%20golden%20and%20amber%20accents%2C%20elegant%20minimal%20UI%20showing%20movie%20posters%20grid%2C%20sleek%20modern%20design%20with%20film%20reel%20aesthetic%2C%20luxurious%20dark%20background%20with%20soft%20glow%20highlights%2C%20premium%20streaming%20app%20design&width=480&height=854&seq=app-mobile-01&orientation=portrait"
                alt="四虎影视大全手机观影界面"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}